export enum StateLifeCycle {
  unknown = 0,
  pending = 1,
  working = 2,
  finished = 3,
  waitingForResponse = 4,
  error = 5,
  timeout = 6,
  waitingForHumanInteraction = 7,
  lockedForHumanInteraction = 8,
  scheduledForExecution = 9,
  overriden = 10,
  interacting = 11,
  overridenByTimeout = 12,
  canceled = 13,
  warning = 14,
  suspended = 15,
  pendingTimeout = 16
}
